"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole[UserRole["user"] = 0] = "user";
    UserRole[UserRole["manager"] = 1] = "manager";
    UserRole[UserRole["admin"] = 2] = "admin";
    UserRole[UserRole["superAdmin"] = 3] = "superAdmin";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var Locale;
(function (Locale) {
    Locale[Locale["en"] = 0] = "en";
    Locale[Locale["fr"] = 1] = "fr";
    Locale[Locale["es"] = 2] = "es";
    Locale[Locale["de"] = 3] = "de";
    Locale[Locale["pt"] = 4] = "pt";
    Locale[Locale["ja"] = 5] = "ja";
    Locale[Locale["ko"] = 6] = "ko";
})(Locale || (Locale = {}));
